@let isMobileVal = shellState.isMobile();
@let minimized = navState.minimized();
@let forceMaximized = navState.forceMaximized();

@let sidebarWidth =
  navState.minimized()
    ? TELLENT_APP_SHELL_LAYOUT.sidebarMinimizedWidth
    : TELLENT_APP_SHELL_LAYOUT.sidebarExpandedWidth;

<div class="sidebar-content" [style.width.px]="sidebarWidth">
  <div class="sidebar-switcher-wrapper">
    <tlc-app-switcher-next
      [walkthroughId]="appSwitcherWalkthroughId()"
      (dropdownOpenChange)="onDropdownOpenChange($event)"
    />
  </div>

  <div class="sidebar-content-wrapper">
    <div class="sidebar-navigation-wrapper" cdkScrollable>
      <tlc-navigation [walkthroughId]="navigationWalkthroughId()" />
    </div>

    @if (!isMobileVal) {
      <tlc-main-navigation-toggle
        (click)="toggleSidebarMinimized(!forceMaximized ? false : !minimized)"
        [forceMaximized]="forceMaximized"
        [minimized]="minimized"
      />
    }
  </div>
</div>

@if (isMobileVal) {
  <div class="sidebar-backdrop" (click)="toggleSidebarMinimized(true)"></div>
}
